import DropDown from "@components/Dropdown";
import Input from "@components/Input";
import { AltText, Column, Row } from "@components/Layout";
import { getVoice } from "@components/TTSEditor/components/ModeSelect/utils";
import UserIcon from "@components/UserIcon";
import { FaSolidAngleDown } from "solid-icons/fa";
import { type VoidComponent, createMemo } from "solid-js";
import { DeleteIcon, DropdownArrow, SlotWrapper } from "./styled";
import type { SlotProps } from "./types";

const Slot: VoidComponent<SlotProps> = (props) => {
	const femaleVoice = createMemo(() => getVoice(props.language, "female"));
	const maleVoice = createMemo(() => getVoice(props.language, "male"));

	return (
		<SlotWrapper gap="10px" alignItems="center" h="150px" padding="10px">
			<DropDown
				items={[
					{
						label: femaleVoice().name,
						onClick: () => props.onVoice(femaleVoice().code),
					},
					{
						label: maleVoice().name,
						onClick: () => props.onVoice(maleVoice().code),
					},
				]}
			>
				<Row
					w="max-content"
					gap="5px"
					alignItems="center"
					onmouseenter={props.onDisableDrag}
					onmouseleave={props.onEnableDrag}
				>
					<UserIcon diameter="50px" src={`/faces/${props.block.languageCode}/${props.block.voice}.webp`} />
					<AltText>
						<DropdownArrow>
							<FaSolidAngleDown />
						</DropdownArrow>
					</AltText>
				</Row>
			</DropDown>
			<Input
				value={props.block.text}
				onChange={props.onValue}
				textArea
				resize="none"
				onmouseenter={props.onDisableDrag}
				onmouseleave={props.onEnableDrag}
			/>
			<Column w="50px" alignItems="center" justifyContent="center">
				<DeleteIcon disabled={!props.onDelete} onclick={props.onDelete} />
			</Column>
		</SlotWrapper>
	);
};
export default Slot;
